import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import DOMPurify from 'dompurify';
import Drawer from '../Drawer';


const PitchPreviewDrawer = ({
  data,
}) => (
  <Drawer>
    <div>
      <Typography variant="h6" component="h6">
        {data.subject}
      </Typography>
      <Divider className="mt-3 mb-3" />
      <Typography
        variant="body2"
        component="p"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.body) }}
      />
    </div>
  </Drawer>
);

PitchPreviewDrawer.propTypes = {
  data: PropTypes.shape({
    subject: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
};

export default PitchPreviewDrawer;
